import {colors} from "../../../../../enums/colors";
import React, {useState} from "react";
import CustomUserChip from "../../../../../components/CustomUserChip";
import {
    chipStatusClassColor,
    chipStatusIconClassColor
} from "../../../../../enums/statusColorEnum";

import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
import {
    DownloadIcon,
    IconFileEmpty,
    IconMaterialType, InfoChip,
    UpdateIcon, CloseIcon
} from "../../../../../components/buttons/IconButtons";
import CustomChip from "../../../../../components/CustomChip";
import {
    downloadActionFile
} from "../../../../../Apis/functions";
import CustomFileCard from "../../../../../components/CustomFileCard";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {getUnitTransByName} from "../../../Dining/Ingredients/Model/Models";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const MaterialDispatchCard = ({
    t,
    item,
    file,
    statusId,
    setShowModal,
    setItemSelected,
    styles,
    generalStatusId,
    emptyFields
}) => {

    const [showBadgeMessage, setShowBadgeMessage] = useState(true);
    const hideBorderTop = showBadgeMessage && file;
    const handleCloseBadge = () => {
        setShowBadgeMessage(false);
    }

    return (
        <>
            { file && showBadgeMessage &&
                <div className={'col-12 p-0'}>
                    <CustomUserChip
                        name={item?.itemEvidence?.note}
                        Icon={InfoChip}
                        showAvatar={true}
                        className={`${chipStatusClassColor[statusId]} w-100 m-0 px-1 py-2 justify-content-start border-radius-top-8px`}
                        classNameText={"m-1"}
                        classNameBoxText={"px-1"}
                        variant='large'
                        iconPosition={POSITION_MODEL.LEFT}
                        onDelete={() => handleCloseBadge() }
                        deleteIcon={<CloseIcon height={16} width={16} className={`${chipStatusIconClassColor[statusId]}`}/>}
                        classNameIcon={"icon-color-secondary-700 w-h-24px"}
                    />
                </div>
            }
            <div className='d-flex justify-content-start'>
                <div style={styles.container} className={`${hideBorderTop && 'border-top-0 border-radius-bottom-8px'}`}>
                    <div style={styles.levelCard} className={`d-flex justify-content-between ${hideBorderTop && 'border-radius-0' }`}>
                        <div>
                            <div className='d-flex justify-content-start align-items-center'>
                                <p style={styles.level}>{item?.name}</p>
                                <div className="vertical-separator-shades-950 h-auto" />
                                <CustomChip
                                    background={colors.secondary100}
                                    fontColor={colors.secondary700}
                                    borderColor={colors.secondary150}
                                    legend={`${item.quantity} ${t(getUnitTransByName(item.measurementUnitName))}`}
                                    icon={<IconMaterialType width={14} height={14} />}
                                    className='icon-color-secondary-700'
                                />
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column w-100 gap-3 p-16px'>
                        <div>
                            {!file ?
                                <CustomFileCard
                                    downloadAtEnd
                                    showIcon={true}
                                    fileValue={null}
                                    title={t(`upload_file`)}
                                    Icon={IconFileEmpty}
                                    showBtnDownload={false}
                                    extraActions={[
                                        <ButtonAction
                                            key={`btn_mdc_upload_${item?.id}`}
                                            Icon={UpdateIcon}
                                            id={`btn_mdc_download_${item?.id}`}
                                            className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                            iconClass={'mr-0'}
                                            onClick={() => {
                                                setShowModal(true);
                                                setItemSelected(item);
                                            }}
                                        />
                                    ]}
                                    classContent="pb-3"
                                    required={true}
                                    emptyFields={emptyFields}
                                />
                                :
                                <>
                                    <CustomFileCard
                                        downloadAtEnd
                                        showIcon={true}
                                        Icon={file.Icon}
                                        title={file.userFileName}
                                        subtitle={file.size}
                                        fileValue={file.filePath}
                                        showBtnDownload={false}
                                        extraActions={
                                            <div className={"d-flex gap-2"}>
                                                <ButtonAction
                                                    key={`btn_mdc_download_${item?.id}`}
                                                    Icon={DownloadIcon}
                                                    id={`btn_mdc_download_${item?.id}`}
                                                    className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                    iconClass={'mr-0'}
                                                    onClick={() => {
                                                        downloadActionFile(file?.filePath);
                                                    }}
                                                />
                                                { ![STATUS_MODEL.DISPATCHED, STATUS_MODEL.DISCREPANCY].includes(generalStatusId) &&
                                                    <ButtonAction
                                                        key={`btn_mdc_upload_${item?.id}`}
                                                        Icon={UpdateIcon}
                                                        id={`btn_mdc_download_${item?.id}`}
                                                        className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                        iconClass={'mr-0'}
                                                        onClick={() => {
                                                            setShowModal(true);
                                                            setItemSelected(item);
                                                        }}
                                                    />
                                                }
                                            </div>
                                        }
                                        classContent="pb-3"
                                        required={true}
                                    />
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default MaterialDispatchCard
